import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {Image, Section} from '@primer/react-brand/esm'
import type {ResourcesSectionContent} from '../../content'
import {Cards} from '../../_components/Cards/Cards'

import styles from './ResourcesSection.module.css'

type Props = {
  contentfulContent: ResourcesSectionContent
}

export function ResourcesSection({contentfulContent}: Props) {
  const sectionId = contentfulContent.section.fields.htmlId
  const sectionIntro = contentfulContent.sectionIntro
  const cards = contentfulContent.cards

  const divider = contentfulContent.divider
  const dividerAsset = divider?.fields.media?.[0]?.fields.asset?.fields
  const dividerFile = dividerAsset?.file

  return (
    <Section id={sectionId} fullWidth paddingBlockEnd="none">
      {sectionIntro ? <ContentfulSectionIntro component={sectionIntro} /> : null}
      {cards ? <Cards component={cards} /> : null}

      {dividerFile ? (
        <Section as="div" variant="gridline" paddingBlockStart="none" paddingBlockEnd="none" data-padding-inline="0">
          <Image
            className={styles.Divider}
            src={dividerFile.url}
            width={dividerFile.details?.image?.width}
            height={dividerFile.details?.image?.height}
            alt={dividerAsset.description || ''}
          />
        </Section>
      ) : null}
    </Section>
  )
}
